module.exports = __webpack_public_path__ + "static/ff-landing-image-header-MFFlaurel.2a51bb56.png";